<template lang="html">

    <section class="banner-rrss" :show="show">

        <h3>{{$t('bannerRRSS.siguenos')}}</h3>
        <nav class="column-center rrss">
            <a class="facebook" href="https://www.facebook.com/Fiesta.ES/" target="_blank"><i
                    class="fa fa-facebook"></i></a>
            <a class="twitter" href="https://twitter.com/FIESTA_es" target="_blank"><i class="fa fa-twitter"></i></a>
            <a class="instagram" href="https://www.instagram.com/fiesta.es/" target="_blank"><i
                    class="fa fa-instagram"></i></a>

        </nav>

        <img src="/static/img/fresquito-to-left.png" class="fresquito" :alt="$t('bannerRRSS.claim')">

        <div class="bocadillo">
            <p>{{$t('bannerRRSS.claim')}}</p>
        </div>

        <button @click="show = 'min'" class="cerrar">✕</button>

    </section>

</template>

<script lang="js">


    export default {
        name: 'banner-rrss',
        mounted() {
            setTimeout(e => {
                this.show = true;

                setTimeout(e => {
                    this.show = false;
                }, 5000);

            }, 6000);
        },
        data() {
            return {
                show: false
            }
        },
    }
</script>

<style scoped lang="scss">
    @media screen and (max-height:650px) {
        .banner-rrss {
            top: calc(50% + 80px);
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/parts/banner-rrss.vue